import axios from 'axios';
import fileDownload from 'js-file-download';
import * as endpoint from '../../../endpoint';
import { consolelog } from '../../../../lib/tools';
import { handleErrorResponse, handleErrorResponseType } from '../../apis';
import { configureAxiosForBlob } from '../../axiosConfig';

/**
 * 特定のタグセットに関連する全タグ情報をCSV形式で出力する。
 * APIを呼び出し、レスポンスとして受け取ったCSVデータをダウンロードする。
 * TODO:タグセットが選択されていない時のエラーメッセージ実装
 *
 * @param {string} apiToken - APIトークン。
 * @param {string} selectedTagSetId - 選択中のタグセットのID。
 */
const exportTags = (apiToken, selectedTagSetId) => dispatch => {
  consolelog('[API CALL] exportTags()');
  configureAxiosForBlob(apiToken);
  const url = endpoint.API_EXPORT_TAGS.replace('{tagSetId}', selectedTagSetId);
  return axios
    .get(url)
    .then(res => {
      const filename = res.headers['content-disposition'].split('=')[1];
      fileDownload(res.data, filename);
    })
    .catch(thrown => {
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch, handleErrorResponseType.tags);
      }
    });
};

export default exportTags;
